<template>
	<v-form class="simple-form">
		<slot />
	</v-form>
</template>

<style scoped lang="scss">
.simple-form {
	display: flex;
	flex-direction: column;
	height: fit-content;
	gap: var(--sk-spacing-sm);
}
</style>

<script setup lang="ts">
import { VForm } from 'vuetify/components';
</script>
